import React from "react";

export default function WhatDoYouDo(props) {
  return (
    <>
      <a
        href="#"
        className="explain-my-data"
        data-bs-toggle="modal"
        data-bs-target="#my-data"
      >
        What do you do with my information?
      </a>
      <div
        className="modal fade"
        id="my-data"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="my-data"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                What do you do with my information?
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>
                We take the privacy and security of any data you provide us very
                seriously.
              </p>
              <p>
                We will never profit by directly selling or giving your
                information to anyone else.
              </p>
              <p>
                <a href="/privacy">Read our full privacy policy here.</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
